/**
 * POS-FULFILLMENT MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point for the pos-fulfillment module. The app composition root
// imports ONLY from here; nothing deep-imports this module's internals.
//
// Two screens (split from the single the source app "POS & Samples" surface):
//   /pos-orders     — Point of Sales Orders  (POSRequestPage)
//   /sample-orders  — Product Sample Orders   (ProductSamplePage)
import PosOrders from "./routes/PosOrders.jsx";
import SampleOrders from "./routes/SampleOrders.jsx";

export const posFulfillmentRoutes = [
  { path: "/pos-orders", component: PosOrders },
  { path: "/sample-orders", component: SampleOrders },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "pos-fulfillment", label: "POS & Fulfillment" };
